var PartnerType;
(function (PartnerType) {
    PartnerType["InboundApi"] = "insulet";
    PartnerType["Redox"] = "redox";
    PartnerType["PartnerApi"] = "api";
    PartnerType["CommercialAPI"] = "commercialapi";
})(PartnerType || (PartnerType = {}));
export default PartnerType;
